import { getUserInitials } from "@/components/ui/user-avatar";

/**
 * Only the uploader's display name reaches the document list
 * (`documents.created_by_name`, `first_name + " " + last_name`), so it is split
 * back into a profile shape: the first word, and the rest. The rest keeps every
 * later word, so `getUserDisplayName` rebuilds the exact name the row shows.
 */
export function splitDisplayName(name: string): { first_name: string; last_name: string } {
  const words = name.trim().split(/\s+/).filter(Boolean);
  return { first_name: words[0] ?? "", last_name: words.slice(1).join(" ") };
}

/** The profile's own initials rule (`getUserInitials`), over the split name. */
export function uploaderInitials(name: string | null | undefined): string {
  const trimmed = name?.trim();
  if (!trimmed) return "";
  return getUserInitials({ ...splitDisplayName(trimmed), email: "" });
}
